import { Select, Stack, Text } from '@mantine/core';
import { DateTime } from 'luxon';
import { FormattedMessage, useIntl } from 'react-intl';

import { messages } from '../../purchase-shipment-volume/messages';

import type { ShipmentTopupTier } from '@shipstation/client-common/api/shipment-topup-tiers.api';

type AmountSelectProps = {
  topupTiers: ShipmentTopupTier[];
  value: number | null;
  onChange: (quantity: number | null) => void;
  shipmentPeriodEnd: string | null;
  currencyCode: string;
  disabled?: boolean;
};

export const AmountSelect = ({ topupTiers, value, onChange, shipmentPeriodEnd, currencyCode, disabled = false }: AmountSelectProps) => {
  const intl = useIntl();

  const options = topupTiers.map((tier) => ({
    value: String(tier.quantity),
    label: intl.formatMessage(messages.amountOptionLabel, {
      quantity: intl.formatNumber(tier.quantity),
      price: intl.formatNumber(tier.price, { style: 'currency', currency: currencyCode }),
    }),
  }));

  const handleChange = (newValue: string | null) => {
    onChange(newValue ? Number(newValue) : null);
  };

  const renewalDate = shipmentPeriodEnd ? DateTime.fromISO(shipmentPeriodEnd).toLocaleString(DateTime.DATE_MED) : '';

  return (
    <Stack gap={4}>
      <Select
        data={options}
        disabled={disabled}
        label={intl.formatMessage(messages.selectAmountLabel)}
        onChange={handleChange}
        value={value ? String(value) : null}
      />
      <Text c='dimmed' size='xs'>
        <FormattedMessage {...messages.amountExpirationHelperText} values={{ renewalDate }} />
      </Text>
    </Stack>
  );
};
